import Login from './login'
import Logout from './logout'
import Register from './register'
import ForgotPassword from './forgot-password'
import PasswordReset from './PasswordReset'
import VerifyAccount from './VerifyAccount'

export { Logout, Register, ForgotPassword, PasswordReset, VerifyAccount }
export default Login
